var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Внесение данных")]),_c('el-divider'),_c('h4',[_vm._v("Результаты поиска")]),_c('data-entry-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }